/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { TimeFieldDisplay } from "./display";
import { TimeFieldEdit } from "./edit";

const TimeField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <TimeFieldDisplay />,
        editComponent: <TimeFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
TimeField.displayName = " TimeField";
export { TimeField };
